import { useTranslation } from 'react-i18next';
import { CardNoBorder } from '../../Components/index';
import { BsFileEarmarkRuled, BsFileEarmarkPersonFill } from "react-icons/bs";
import { PiHandshake } from "react-icons/pi";
import { LuMedal } from "react-icons/lu";
import { IoPersonAddOutline } from "react-icons/io5";
import { LuFiles } from "react-icons/lu";



const LawnexData = () => {
    const { t, i18n } = useTranslation();

    let LawnexDataArr = [
        {id: '1', icon: <LuFiles />     , title: '39061', info: 'وحدة قانونية'},
        {id: '2', icon: <LuFiles />     , title: '75565', info: 'اجتهاد قضائي'},
        {id: '3', icon: <LuFiles />            , title: '447', info: 'نموذج عقد'},
        {id: '4', icon: <LuFiles />                , title:'648', info: 'نموذج دعوى'}
    ]

    let lawnexCards = LawnexDataArr.map(card => {
        return <CardNoBorder key={card.id} icon={card.icon} title={card.title} info={card.info} />
      })

    return (
        <>
        {lawnexCards}
        </>
    )
}



export default LawnexData;